export const COMPOSER_ATTACHMENT_LIMIT = 5
export const COMPOSER_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024
export const COMPOSER_ATTACHMENT_MIME_TYPES = new Set([
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/webp",
])
const COMPOSER_ATTACHMENT_EXTENSIONS = new Set([
  ".docx",
  ".gif",
  ".jpeg",
  ".jpg",
  ".pdf",
  ".png",
  ".webp",
])
export const COMPOSER_ATTACHMENT_ACCEPT = [
  ...COMPOSER_ATTACHMENT_MIME_TYPES,
  ...COMPOSER_ATTACHMENT_EXTENSIONS,
].join(",")

type DraftAttachmentLike = {
  file: File
}

export function isAllowedComposerFile(file: File): boolean {
  return (
    COMPOSER_ATTACHMENT_MIME_TYPES.has(file.type) ||
    COMPOSER_ATTACHMENT_EXTENSIONS.has(fileExtension(file.name))
  )
}

export function totalDraftAttachmentBytes(
  attachments: DraftAttachmentLike[],
): number {
  return attachments.reduce((total, attachment) => total + attachment.file.size, 0)
}

export function formatComposerBytes(sizeBytes: number): string {
  if (!Number.isFinite(sizeBytes) || sizeBytes <= 0) return "0 B"
  const units = ["B", "KB", "MB", "GB"]
  let value = sizeBytes
  let unit = 0
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit += 1
  }
  return `${value >= 10 || unit === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[unit]}`
}

export function pdfDraftThumbnailUrl(url: string): string {
  return `${url}#page=1&toolbar=0&navpanes=0&scrollbar=0&view=FitH`
}

export function draftMiniatureLineWidths(seed: string): number[] {
  const source = seed.trim() || "attachment"
  let hash = 0
  for (const char of source) {
    hash = (hash * 31 + char.charCodeAt(0)) % 997
  }
  return [82, 64, 76, 52].map((base, index) => {
    const variance = (hash + index * 17) % 14
    return Math.max(42, Math.min(88, base - variance))
  })
}

export function composerAttachmentTypeLabel(file: File): string {
  if (file.type.startsWith("image/")) return "Image"
  if (file.type === "application/pdf") return "PDF"
  if (
    file.type ===
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return "DOCX"
  }
  return "File"
}

export function fileExtensionLabel(file: File): string {
  const extension = fileExtension(file.name).slice(1)
  return extension ? extension.slice(0, 5).toUpperCase() : composerAttachmentTypeLabel(file)
}

function fileExtension(fileName: string): string {
  const dotIndex = fileName.lastIndexOf(".")
  if (dotIndex <= 0 || dotIndex === fileName.length - 1) return ""
  return fileName.slice(dotIndex).trim().toLowerCase()
}
